export const heroStats = [
  { id: "stat-platform", value: "12+", label: "正版观看平台" },
  { id: "stat-title", value: "40+", label: "精选片单条目" },
  { id: "stat-lang", value: "2", label: "日 / 韩 语种分区" },
  { id: "stat-sub", value: "4", label: "常见字幕类型" },
];

export const featuredPicks = [
  {
    id: "pick-1",
    title: "请回答1988",
    meta: "韩剧 · 家庭 / 青春",
    note: "怀旧群像剧，双门洞的邻里日常，官方中文字幕排版清晰。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20retro%20movie%20poster%20style%20cover%20showing%20a%20sunlit%20old%20seoul%20alley%20with%20bicycles%20and%20hanging%20laundry%2C%20amber%20and%20terracotta%20color%20grade%2C%20soft%20film%20grain%2C%20minimal%20elegant%20composition%2C%20no%20text&width=600&height=900&seq=guide-cover-01&orientation=portrait",
  },
  {
    id: "pick-2",
    title: "重启人生",
    meta: "日剧 · 奇幻 / 剧情",
    note: "关于人生重来的温柔叙事，台词密，字幕与语境贴合度高。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20minimal%20movie%20poster%20style%20cover%20showing%20a%20quiet%20japanese%20suburban%20street%20at%20golden%20hour%20with%20a%20lone%20streetlight%2C%20amber%20and%20moss%20green%20color%20grade%2C%20soft%20film%20grain%2C%20elegant%20negative%20space%2C%20no%20text&width=600&height=900&seq=guide-cover-02&orientation=portrait",
  },
  {
    id: "pick-3",
    title: "寄生虫",
    meta: "韩影 · 剧情 / 悬疑",
    note: "结构精巧的阶层寓言，字幕需要处理大量空间与隐喻。",
    cover:
      "https://readdy.ai/api/search-image?query=dramatic%20minimal%20movie%20poster%20style%20cover%20showing%20a%20narrow%20basement%20window%20with%20warm%20light%20piercing%20through%20dust%2C%20amber%20and%20deep%20charcoal%20color%20grade%2C%20soft%20film%20grain%2C%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=guide-cover-03&orientation=portrait",
  },
  {
    id: "pick-4",
    title: "海街日记",
    meta: "日影 · 家庭 / 治愈",
    note: "镰仓四季与四姐妹，画面柔和，字幕节奏舒缓。",
    cover:
      "https://readdy.ai/api/search-image?query=gentle%20movie%20poster%20style%20cover%20showing%20a%20seaside%20japanese%20town%20with%20cherry%20blossoms%20and%20blue%20skies%20reflected%20in%20water%2C%20soft%20warm%20and%20green%20color%20grade%2C%20film%20grain%2C%20serene%20composition%2C%20no%20text&width=600&height=900&seq=guide-cover-04&orientation=portrait",
  },
];

export const platforms = [
  {
    id: "platform-netflix",
    name: "Netflix",
    region: "全球多数地区",
    icon: "ri-netflix-fill",
    highlight: "官方简繁中文字幕",
    desc: "日韩原创剧集与电影片库丰富，字幕由平台统一制作，可在播放页自由开关。",
    tags: ["日剧", "韩剧", "电影", "多语字幕"],
  },
  {
    id: "platform-viki",
    name: "Viki",
    region: "北美 / 欧洲 / 东南亚",
    icon: "ri-global-line",
    highlight: "社区协作多语字幕",
    desc: "主打亚洲剧集，字幕由志愿者与官方协作翻译，更新速度常与上线同步。",
    tags: ["亚洲剧", "多语种", "社区字幕"],
  },
  {
    id: "platform-we",
    name: "WeTV / 爱奇艺国际版",
    region: "东南亚 / 港台",
    icon: "ri-play-circle-line",
    highlight: "部分日韩版权剧带中文",
    desc: "以华语内容为主，同时引进部分日韩剧集，多数提供简体或繁体中文字幕。",
    tags: ["版权引进", "简体", "繁体"],
  },
  {
    id: "platform-bilibili",
    name: "哔哩哔哩",
    region: "中国大陆",
    icon: "ri-bilibili-line",
    highlight: "正版日番与引进剧",
    desc: "正版引进大量日番、部分日韩剧集与电影，官方字幕质量稳定，弹幕为额外体验。",
    tags: ["日番", "正版", "官方字幕"],
  },
  {
    id: "platform-tencent",
    name: "腾讯视频 / 优酷 / 芒果TV",
    region: "中国大陆",
    icon: "ri-tv-2-line",
    highlight: "国内正版片库",
    desc: "以版权采购形式上线日韩剧集与电影，字幕以简体中文为主，部分支持多音轨。",
    tags: ["简体中文", "版权片库"],
  },
  {
    id: "platform-disney",
    name: "Disney+",
    region: "部分地区",
    icon: "ri-award-line",
    highlight: "日韩原创与片库",
    desc: "上线多部韩国原创剧集与日本影视内容，播放器内置中文字幕轨，可自由切换。",
    tags: ["原创剧", "电影", "字幕轨"],
  },
  {
    id: "platform-prime",
    name: "Prime Video",
    region: "全球多数地区",
    icon: "ri-amazon-fill",
    highlight: "可选字幕语言",
    desc: "日韩影视片库随地区不同，可在设置中选择字幕语言，部分内容需额外订阅。",
    tags: ["地区差异", "字幕可选"],
  },
  {
    id: "platform-apple",
    name: "Apple TV / 正版点播",
    region: "全球多数地区",
    icon: "ri-apple-fill",
    highlight: "单片购买或租赁",
    desc: "日韩电影多以单片购买 / 租赁形式提供，购前可查看是否附带中文字幕。",
    tags: ["单片点播", "买断租赁"],
  },
];

export const titles = [
  {
    id: "t-1",
    title: "请回答1988",
    lang: "韩",
    type: "剧集",
    year: 2015,
    genres: ["家庭", "青春", "怀旧"],
    rating: 9.7,
    blurb: "双门洞五户人家的群像日常，怀旧与亲情并重，适合一次看完一整季。",
    availability: "主流正版平台",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20retro%20movie%20poster%20style%20cover%20showing%20a%20sunlit%20old%20seoul%20alley%20with%20bicycles%20and%20hanging%20laundry%2C%20amber%20and%20terracotta%20color%20grade%2C%20soft%20film%20grain%2C%20minimal%20elegant%20composition%2C%20no%20text&width=600&height=900&seq=guide-title-01&orientation=portrait",
  },
  {
    id: "t-2",
    title: "信号",
    lang: "韩",
    type: "剧集",
    year: 2016,
    genres: ["悬疑", "犯罪", "穿越"],
    rating: 9.2,
    blurb: "通过对讲机连接过去与现在的刑警，案件改编自真实事件，节奏紧凑。",
    availability: "主流正版平台",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20movie%20poster%20style%20cover%20showing%20an%20old%20walkie%20talkie%20on%20a%20rainy%20window%20ledge%20at%20night%2C%20deep%20charcoal%20and%20amber%20color%20grade%2C%20soft%20film%20grain%2C%20tense%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=guide-title-02&orientation=portrait",
  },
  {
    id: "t-3",
    title: "我的解放日志",
    lang: "韩",
    type: "剧集",
    year: 2022,
    genres: ["治愈", "剧情"],
    rating: 8.9,
    blurb: "三个兄妹与一个神秘外乡人的乡野日常，台词克制，字幕处理尤为关键。",
    availability: "主流正版平台",
    cover:
      "https://readdy.ai/api/search-image?query=quiet%20movie%20poster%20style%20cover%20showing%20a%20korean%20rural%20field%20at%20dusk%20with%20a%20lone%20figure%20walking%2C%20muted%20olive%20and%20amber%20color%20grade%2C%20film%20grain%2C%20melancholic%20composition%2C%20no%20text&width=600&height=900&seq=guide-title-03&orientation=portrait",
  },
  {
    id: "t-4",
    title: "爱的迫降",
    lang: "韩",
    type: "剧集",
    year: 2019,
    genres: ["爱情", "喜剧"],
    rating: 8.7,
    blurb: "跨越边境线的爱情喜剧，名场面多，适合作为入门韩剧的第一部。",
    availability: "主流正版平台",
    cover:
      "https://readdy.ai/api/search-image?query=romantic%20movie%20poster%20style%20cover%20showing%20a%20misty%20mountain%20border%20landscape%20at%20sunrise%2C%20soft%20rose%20and%20amber%20color%20grade%2C%20film%20grain%2C%20dreamy%20composition%2C%20no%20text&width=600&height=900&seq=guide-title-04&orientation=portrait",
  },
  {
    id: "t-5",
    title: "孤独的美食家",
    lang: "日",
    type: "剧集",
    year: 2012,
    genres: ["美食", "日常"],
    rating: 9.1,
    blurb: "井之头五郎走街串巷寻找小馆子，字幕对菜名与方言的处理很有参考价值。",
    availability: "主流正版平台",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20movie%20poster%20style%20cover%20showing%20a%20tiny%20japanese%20izakaya%20counter%20with%20steaming%20dishes%20under%20warm%20lamplight%2C%20amber%20and%20brown%20color%20grade%2C%20film%20grain%2C%20intimate%20composition%2C%20no%20text&width=600&height=900&seq=guide-title-05&orientation=portrait",
  },
  {
    id: "t-6",
    title: "逃避虽可耻但有用",
    lang: "日",
    type: "剧集",
    year: 2016,
    genres: ["爱情", "喜剧"],
    rating: 8.4,
    blurb: "契约婚姻设定的轻喜剧，节奏轻快，字幕亮点在于生活化口语的还原。",
    availability: "主流正版平台",
    cover:
      "https://readdy.ai/api/search-image?query=bright%20movie%20poster%20style%20cover%20showing%20a%20tidy%20japanese%20apartment%20living%20room%20with%20sunlight%20and%20plants%2C%20soft%20amber%20and%20green%20color%20grade%2C%20film%20grain%2C%20cheerful%20composition%2C%20no%20text&width=600&height=900&seq=guide-title-06&orientation=portrait",
  },
  {
    id: "t-7",
    title: "重启人生",
    lang: "日",
    type: "剧集",
    year: 2023,
    genres: ["奇幻", "剧情"],
    rating: 9.0,
    blurb: "以“重来一次”为结构，把琐碎日常写得意蕴悠长，台词密集需细看字幕。",
    availability: "主流正版平台",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20minimal%20movie%20poster%20style%20cover%20showing%20a%20quiet%20japanese%20suburban%20street%20at%20golden%20hour%20with%20a%20lone%20streetlight%2C%20amber%20and%20moss%20green%20color%20grade%2C%20soft%20film%20grain%2C%20elegant%20negative%20space%2C%20no%20text&width=600&height=900&seq=guide-title-07&orientation=portrait",
  },
  {
    id: "t-8",
    title: "海街日记",
    lang: "日",
    type: "电影",
    year: 2015,
    genres: ["家庭", "治愈"],
    rating: 8.7,
    blurb: "镰仓四季与四姐妹的生活切片，画面柔和，台词留白多，字幕需克制。",
    availability: "正版点播 / 平台",
    cover:
      "https://readdy.ai/api/search-image?query=gentle%20movie%20poster%20style%20cover%20showing%20a%20seaside%20japanese%20town%20with%20cherry%20blossoms%20and%20blue%20skies%20reflected%20in%20water%2C%20soft%20warm%20and%20green%20color%20grade%2C%20film%20grain%2C%20serene%20composition%2C%20no%20text&width=600&height=900&seq=guide-title-08&orientation=portrait",
  },
  {
    id: "t-9",
    title: "小偷家族",
    lang: "日",
    type: "电影",
    year: 2018,
    genres: ["剧情", "家庭"],
    rating: 8.6,
    blurb: "没有血缘的一家人，靠微薄收入相互取暖，字幕需要拿捏伦理与温度。",
    availability: "正版点播 / 平台",
    cover:
      "https://readdy.ai/api/search-image?query=gritty%20movie%20poster%20style%20cover%20showing%20an%20old%20japanese%20wooden%20house%20at%20dusk%20with%20warm%20window%20light%2C%20muted%20amber%20and%20charcoal%20color%20grade%2C%20film%20grain%2C%20nostalgic%20composition%2C%20no%20text&width=600&height=900&seq=guide-title-09&orientation=portrait",
  },
  {
    id: "t-10",
    title: "寄生虫",
    lang: "韩",
    type: "电影",
    year: 2019,
    genres: ["剧情", "悬疑"],
    rating: 8.7,
    blurb: "结构精巧的阶层寓言，空间与道具承载大量隐喻，字幕翻译常被讨论。",
    availability: "正版点播 / 平台",
    cover:
      "https://readdy.ai/api/search-image?query=dramatic%20minimal%20movie%20poster%20style%20cover%20showing%20a%20narrow%20basement%20window%20with%20warm%20light%20piercing%20through%20dust%2C%20amber%20and%20deep%20charcoal%20color%20grade%2C%20soft%20film%20grain%2C%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=guide-title-10&orientation=portrait",
  },
  {
    id: "t-11",
    title: "你的名字。",
    lang: "日",
    type: "电影",
    year: 2016,
    genres: ["动画", "爱情"],
    rating: 8.8,
    blurb: "身体互换引发的青春奇幻，配乐与字幕同步感强，适合大屏观看。",
    availability: "正版点播 / 平台",
    cover:
      "https://readdy.ai/api/search-image?query=magical%20anime%20movie%20poster%20style%20cover%20showing%20a%20comet%20streaking%20over%20a%20japanese%20mountain%20town%20at%20twilight%2C%20amber%20and%20teal%20green%20color%20grade%2C%20soft%20glow%2C%20romantic%20composition%2C%20no%20text&width=600&height=900&seq=guide-title-11&orientation=portrait",
  },
  {
    id: "t-12",
    title: "燃烧",
    lang: "韩",
    type: "电影",
    year: 2018,
    genres: ["悬疑", "剧情"],
    rating: 8.0,
    blurb: "改编自村上春树短篇，留白与悬念并重，字幕的模糊感是观影体验的一部分。",
    availability: "正版点播 / 平台",
    cover:
      "https://readdy.ai/api/search-image?query=mysterious%20movie%20poster%20style%20cover%20showing%20an%20orange%20sunset%20over%20an%20empty%20field%20with%20a%20lone%20burning%20greenhouse%2C%20amber%20and%20deep%20green%20color%20grade%2C%20film%20grain%2C%20enigmatic%20composition%2C%20no%20text&width=600&height=900&seq=guide-title-12&orientation=portrait",
  },
];

export const subtitleTypes = [
  {
    id: "sub-official",
    name: "官方字幕",
    icon: "ri-shield-check-line",
    desc: "由版权方或平台字幕部门制作，术语与译名统一，质量稳定，通常可在播放器内开关。",
    best: "适合第一次观看、追求稳定体验的观众。",
  },
  {
    id: "sub-studio",
    name: "平台精译",
    icon: "ri-quill-pen-line",
    desc: "人工翻译基础上经过校对与本地化，兼顾口语习惯与原著语境，注释更细致。",
    best: "适合台词密集、文化梗较多的剧集。",
  },
  {
    id: "sub-community",
    name: "社区协作字幕",
    icon: "ri-team-line",
    desc: "由爱好者社区协作翻译，风格灵活、更新快，但质量参差，来源需自行甄别合法性。",
    best: "适合正版尚未上线的冷门作品，注意版权。",
  },
  {
    id: "sub-soft",
    name: "软字幕 / 硬字幕",
    icon: "ri-toggle-line",
    desc: "软字幕是独立字幕轨，可随时开关与切换；硬字幕已烧录进画面，无法关闭。",
    best: "需要切换语言或不看字幕时，优先选软字幕。",
  },
];

export const tips = [
  {
    id: "tip-1",
    step: "01",
    title: "先确认字幕是否可开关",
    desc: "播放页若能调出字幕语言菜单，说明是软字幕，看剧时更自由；只有画面里的字则多为硬字幕。",
  },
  {
    id: "tip-2",
    step: "02",
    title: "留意字幕语言与译名",
    desc: "同一部作品在不同平台可能用不同译名，认准你熟悉的叫法，避免看错版本。",
  },
  {
    id: "tip-3",
    step: "03",
    title: "按语种习惯选择平台",
    desc: "偏爱日剧可优先日番与日剧片库较强的平台；偏爱韩剧则看原创剧与韩剧采购较多的平台。",
  },
  {
    id: "tip-4",
    step: "04",
    title: "地区差异提前确认",
    desc: "同一平台在不同国家 / 地区上架的内容与字幕轨可能不同，出行或换区前先确认。",
  },
  {
    id: "tip-5",
    step: "05",
    title: "支持正版，规避风险",
    desc: "通过正版平台观看既能获得稳定字幕与画质，也能避免弹窗、捆绑与隐私风险。",
  },
];

export const faqs = [
  {
    id: "faq-1",
    q: "日韩剧集的中文字幕一般在哪里能看到？",
    a: "多数正版流媒体平台会在播放器中提供简体或繁体中文字幕轨，例如日韩原创内容较丰富的国际平台，以及国内引进日韩剧集的视频平台。具体是否附带中文字幕，以该平台对应地区的上线信息为准。",
  },
  {
    id: "faq-2",
    q: "为什么同一部剧在不同平台字幕不太一样？",
    a: "字幕由各平台自行制作或委托翻译，译名、语气、注释详略会存在差异。官方字幕通常更统一，社区协作字幕则风格灵活但质量不一，两者各有适用场景。",
  },
  {
    id: "faq-3",
    q: "中文字幕有简体和繁体之分吗？",
    a: "有。面向大陆地区的平台多以简体中文为主，面向港台或海外华人的平台则可能提供繁体中文，部分平台同时提供两种，可在字幕菜单中切换。",
  },
  {
    id: "faq-4",
    q: "找不到中文字幕怎么办？",
    a: "先确认当前地区是否上架该作品，以及是否被归入需要额外订阅的内容；再检查播放器字幕菜单是否被隐藏。若正版确实未提供中文字幕，建议等待官方更新，而非使用来源不明的资源。",
  },
  {
    id: "faq-5",
    q: "手机、平板和电视端都能看到同样的字幕吗？",
    a: "同一账号在不同设备上通常共享字幕设置，但个别平台的字幕菜单位置与可选语言会因客户端版本不同而有差异，更新到较新版本体验更一致。",
  },
  {
    id: "faq-6",
    q: "为什么有些剧集换了地区就看不到了？",
    a: "影视内容的版权通常按国家 / 地区分别授权，同一平台在不同地区的片库并不相同。更换地区后出现无法播放属于正常的版权区域限制。",
  },
];